/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { IWizardMultiSearchTranslation } from '../../types';

export const initWizardMultiSearchTranslation: IWizardMultiSearchTranslation = {
    title: '',
    steps: {
        MsisdnDocumentSelectionStep: '',
    },
    error: {
        codes: {},
        defaultMessage: '',
    },

    validateErrors: {
        file: '',
        foundMsisdnsCount: '',
    },

    MsisdnDocumentSelectionStep: {
        info: '',
        maxImportSubs: '',
        template: '',
        templateUrl: '',
        title: '',
        warning: '',
    },
    ConfirmSelectionStep: {
        exportButton: '',
        subscribersFound: '',
        subscribersNotFound: '',
    },
};
